<div class="modal-header">
  <h4 class="modal-title">Werken bij Buurtzorg</h4>
  <button type="button" class="btn-close" nofocus (click)="activeModal.dismiss('close')"></button>
</div>
<div class="modal-body">
  @if (!story.videoUrl && story.imageUrl) {
    <div>
      <img [src]="story.imageUrl" class="img-fluid" />
      <div class="image-overlay text-white px-4 py-2 text-center">
        <p class="m-0 h4 fw-bold">{{ story.title }}</p>
        <p class="h4">{{ story.subtitle }}</p>
      </div>
    </div>
  }

  @if (story.videoUrl) {
    <div class="video-wrapper">
      <div class="ratio ratio-16x9">
        <iframe [src]="sanitizer.bypassSecurityTrustResourceUrl(story.videoUrl)" allowfullscreen="allowfullscreen" class=""></iframe>
      </div>
    </div>
  }

  <p class="lead text-center mt-4">{{ story.lead }}</p>

  <p [innerHTML]="story.body"></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close('close')">Sluiten</button>
</div>
